<template>
	<!-- ACTIVE COMPONENTS -->
	<div class="usuario-cell">
        <div class="usuario-cell-data">
            <!-- <router-link :to="{name: 'Detalle de usuario', params: {id: usuario.usuarios_id, nombre: usuario.nombre}}"> -->
                <b>{{usuario.nombre}} {{usuario.apellidos}}</b> <br>
                <i class="fa fa-user"></i> {{usuario.usuario}} <br>
            <!-- </router-link> -->
            <a :href="'mailto:' + usuario.email">
                <i class="fa fa-envelope"></i> {{usuario.email}}
            </a>
            <br>
            <a v-if="!!usuario.telefono_celular" :href="'tel:' + usuario.telefono_celular">
                <small> <i class="fa fa-phone"></i> {{usuario.telefono_celular}}</small>
            </a>
        </div>
	</div>
	<!-- ACTIVE COMPONENTS -->
</template>

<script>
	export default {
		props: {
			usuario: {
				type: Object,
				required: true
			}
		}
	}
</script>

<style lang="less">
	.usuario-cell {
		@avatarSize: 3.5em;
		position: relative;
		// &-data {
			// margin-left: 4.5em;
		// }
		.api-img {
			padding: 0;
			margin: 0;
			position: absolute;
			top: 0.5em;
			left: 0em;
			width: @avatarSize;
			IMG {
				width: @avatarSize;
				height: @avatarSize;
				border-radius: 50%;
			}
		}
	}
</style>